import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

import CalculatorContext from "../../Context/CalculatorContext";

import { RESULTS_PAGE, STEPS_PAGINATION } from "../../Constants/RouteConstants";

function StepsForm({ children }) {
  const { currentStepIndex } = useContext(CalculatorContext);

  const navigate = useNavigate();

  return (
    <form
      method="post"
      onSubmit={(e) => {
        e.preventDefault();

        if (e.target.checkValidity()) {
          if (STEPS_PAGINATION[currentStepIndex + 1]) {
            navigate(STEPS_PAGINATION[currentStepIndex + 1]);

            return;
          }

          navigate(RESULTS_PAGE);
        } else {
          e.target.reportValidity();
        }
      }}
    >
      {children}
    </form>
  );
}

StepsForm.propTypes = {
  children: PropTypes.node.isRequired,
};

export default StepsForm;
